import React from "react"
import { Chip } from "@mui/material"
import { styled } from "@mui/material/styles"
import { PE_STATUSES } from "../../utils/packagingExecutions"

const statusColors = {
	// For both PSE and PE
	TODO: { color: "#1E86E5", backgroundColor: "#E3F2FD", border: "1px solid #90C9F9" },
	LOCKED: { color: "#555", backgroundColor: "#F8F8F8", border: "1px solid #CCC" },
	IN_PROGRESS: { color: "#B38616", backgroundColor: "#FFF9E8", border: "1px solid #F2C046" },
	DONE: { color: "#368F50", backgroundColor: "#EBF7EE", border: "1px solid #89D69F" },
	FAIL: { color: "#368F50", backgroundColor: "#EBF7EE", border: "1px solid #89D69F" },
	SUCCESS: { color: "#368F50", backgroundColor: "#EBF7EE", border: "1px solid #89D69F" },
	// For PSE
	TO_TEST: { color: "#7900D9", backgroundColor: "#F1E7FF", border: "1px solid #B389FF" },
	LATE: { color: "#CC0030", backgroundColor: "#FFEAEF", border: "1px solid #F1959F" }, // Not exists yet?
	VEILLE: { color: "#607FE0", backgroundColor: "#E3E9F9", border: "1px solid #607FE0" }, // Overnight PSE indicator
	// For PE
	[PE_STATUSES.toValidate]: { color: "#1045A1", backgroundColor: "rgba(227, 233, 249, 0.89)", border: "1px solid #607FE0" }, // Maybe changed later
	INSUFFICIENT_WEIGHT: { color: "#CC0030", backgroundColor: "#FFEAEF", border: "1px solid #F1959F" }, // Maybe changed later
	[PE_STATUSES.waste]: { color: "#7900D9", backgroundColor: "#F1E7FF", border: "1px solid #B389FF" },
	// For reprod
	CANCELLED: { color: "#CC0030", backgroundColor: "#FFEAEF", border: "1px solid #F1959F" }, // Maybe changed later
}

const StyledChip = styled(Chip)(({ status }) => ({
	display: "flex",
	height: 24,
	padding: "4px 8px",
	justifyContent: "center",
	alignItems: "center",
	gap: "4px",
	borderRadius: "999999px",
	fontSize: 16,
	fontStyle: "normal",
	lineHeight: 1.5,
	fontWeight: 400,
	...statusColors[status],
	"& .MuiChip-label": {
		paddingLeft: 0,
		paddingRight: 0
	}
}))

const ExecutionsStatus = ({ statusValue, statusName }) => {
	return (
		<StyledChip label={statusName} status={statusValue} variant="outlined" />
	)
}

export default ExecutionsStatus
